/* eslint dot-notation:0 */
(function(angular) {
    'use strict';

    angular.module('um.filters').controller('filter.userlist.controller', filtersCtrl);

    filtersCtrl.$inject = ['filtersService', '$stateParams', 'usersService', '$q'];

    function filtersCtrl(filtersService, $stateParams, usersService, $q) {
        var that = this;

        this.$onInit = function() {
            that.users = [];
            const promises = [
                filtersService.getFilter($stateParams.filterId),
                usersService.getAllUsers()
            ];

            return $q.all(promises).then(function(values) {
                that.filter = _.nth(values, 0) || {};
                const users = _.nth(values, 1) || [];

                if (_.has(that.filter, 'userIds') && !_.isUndefined(that.filter.userIds)) {
                    that.filter.userIds.forEach(function(userId) {
                        that.users.push(_.find(users, function(user) {
                            return user.id === userId;
                        }));
                    });
                }

                that.setRolesString();
            });
        };

        that.predicate = 'loginName';
        that.reverse = false;
        that.tableHeaders = [
            {
                active: true,
                sortable: true,
                searchable: true,
                predicate: 'loginName',
                i18n: 'USER_LOGIN_NAME',
                reverse: false,
                width: 3
            },
            {
                active: true,
                sortable: true,
                searchable: true,
                predicate: 'fullName',
                i18n: 'USER_FULL_NAME',
                reverse: false,
                width: 3
            },
            {
                active: true,
                sortable: true,
                searchable: true,
                predicate: 'email',
                i18n: 'USER_EMAIL',
                reverse: false,
                width: 3
            },
            {
                active: true,
                sortable: false,
                searchable: true,
                predicate: 'rolesString',
                i18n: 'ROLES',
                reverse: false,
                width: 3
            }
        ];

        that.selectedSearchKey = '$';
        that.elementList = _.filter([{
            active: true,
            searchable: true,
            predicate: '$',
            i18n: 'FILTER_ANY'
        }].concat(that.tableHeaders), function(el) {
            return el.searchable;
        });

        that.search = {
            $: ''
        };

        that.elementMapping = {
            key: 'predicate',
            title: 'i18n',
            active: 'active'
        };

        that.clickHandlers = {
            leftClick: function(index, element) {
                var searchText;
                if (element && element.predicate) {
                    searchText = that.search[that.selectedSearchKey];
                    that.selectedSearchKey = element.predicate;
                    that.search = {};
                    that.search[that.selectedSearchKey] = searchText;
                }
            }
        };

        that.sortHeader = function sortHeader(tableHeader) {
            if (tableHeader.predicate) {
                tableHeader.reverse = !tableHeader.reverse;
                that.predicate = tableHeader.predicate;
                that.reverse = tableHeader.reverse;
            }
        };

        /**
         * Checks the highlighting should be done on search or not
         * That is the case if either 'Any' or the matching predicate is selected
         *
         * @param {String} predicate
         * @returns {*} Value key in search object or false value
         */
        that.checkHighlighting = function checkHighlighting(predicate) {
            if (that.selectedSearchKey === predicate || that.selectedSearchKey === that.elementList[0].predicate) {
                return that.search[that.selectedSearchKey];
            }
            return '';
        };

        /**
        * Make the string that contains all the roles for each user.
        */
        that.setRolesString = function() {
            // TODO: put into service
            that.users.forEach((user) => {
                if (user.roles) {
                    user.rolesString = _.map(user.roles, 'name').join(', ');
                }
            });
        };
    }
})(window.angular);
